import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { BusinessErrorCode } from './contract';

/** Message per stable wire code. Exhaustive: a new code must get a message. */
export const BUSINESS_ERROR_MESSAGE_KEYS: Record<BusinessErrorCode, LocalizationKeys> = {
    CUI_INVALID_FORMAT: LocalizationKeys.BusinessErrorCuiInvalidFormat,
    CUI_NOT_FOUND: LocalizationKeys.BusinessErrorCuiNotFound,
    COMPANY_INELIGIBLE: LocalizationKeys.BusinessErrorCompanyIneligible,
    ANAF_UNAVAILABLE: LocalizationKeys.BusinessErrorAnafUnavailable,
    ANAF_TIMEOUT: LocalizationKeys.BusinessErrorAnafTimeout,
    ANAF_RESPONSE_INVALID: LocalizationKeys.BusinessErrorAnafResponseInvalid,
    COMPANY_STATUS_UNVERIFIED: LocalizationKeys.BusinessErrorCompanyStatusUnverified,
    COMPANY_DATA_INCOMPLETE: LocalizationKeys.BusinessErrorCompanyDataIncomplete,
    LOOKUP_RATE_LIMITED: LocalizationKeys.BusinessErrorLookupRateLimited,
    BILLING_SESSION_EXPIRED: LocalizationKeys.BusinessErrorSessionExpired,
    BILLING_SESSION_UNAUTHORIZED: LocalizationKeys.BusinessErrorSessionUnauthorized,
    BILLING_SESSION_FORBIDDEN: LocalizationKeys.BusinessErrorSessionForbidden,
    VERIFICATION_STALE: LocalizationKeys.BusinessErrorVerificationStale,
    BILLING_REQUEST_INVALID: LocalizationKeys.BusinessErrorRequestInvalid,
    BILLING_INTERNAL_ERROR: LocalizationKeys.BusinessErrorInternal,
};

/** Unknown codes, malformed or non-JSON bodies and network errors: never implies a bad CUI. */
export const BUSINESS_UNKNOWN_MESSAGE_KEY = LocalizationKeys.BusinessVerificationUnknown;
